import { maxBy as G, max as Z, isInteger as U, isEmpty as B } from "lodash-es";
import { Decimal as M } from "decimal.js";
const q = "Inter, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif";
function z(h) {
  return `normal normal 500 ${h}px ${q}`;
}
function x(h) {
  if (h.indexOf(".") > -1) {
    const t = h.substr(0, 5);
    return t.charAt(t.length - 1) === "." ? h.substr(0, 4) : t;
  } else
    return h.substr(0, 4);
}
function K(h) {
  const t = h.toString();
  return h && t.indexOf(".") > -1 && t.split(".")[1].length || null;
}
class _ {
  data;
  decimal;
  leftData;
  rightData;
  minval;
  maxval;
  middlePriceVal;
  ymaxval;
  middle;
  length;
  zoom;
  zoomObj;
  locale;
  localeMap;
  mouseIndex;
  constructor() {
    this.data = { bids: [], asks: [] }, this.decimal = {}, this.leftData = [], this.rightData = [], this.minval = 0, this.maxval = 0, this.middlePriceVal = 0, this.ymaxval = 0, this.middle = 0, this.length = 0, this.mouseIndex = { offsetX: 0 }, this.zoom = -1, this.zoomObj = { xPrice: 0, ySum: 0, dataIndex: 200 };
  }
  init(t, e) {
    this.data = t, t.minval && (this.minval = t.minval), t.maxval && (this.maxval = t.maxval), t.ymaxval && (this.ymaxval = t.ymaxval), t.middlePrice && (this.middlePriceVal = t.middlePrice, this.middle = this.middlePrice()), this.length = 200, this.decimal = e, this.locale = "en", this.localeMap = { en: { price: "Price", sum: "Sum" } };
    const i = this.data.bids, s = this.data.asks;
    this.leftData = this.dataFill(i, "bids"), this.rightData = this.dataFill(s, "asks");
  }
  initData(t) {
    const e = [];
    let i = this.minPrice();
    const s = this.adjacent(), a = s / this.length, o = this.length, n = 0;
    t === "asks" && (i = i + s);
    for (let r = 0; r < o; r++) {
      const d = {
        p: i + a * r,
        v: 0,
        t: n
      };
      e.push(d);
    }
    return t === "asks" ? e : e.reverse();
  }
  dataFill(t, e) {
    const i = this.initData(e), s = this.length, o = this.adjacent() / this.length;
    let n = 0;
    const r = this.minPrice(), d = this.maxPrice();
    for (let l = 0; l < s; l++) {
      const c = i[l];
      t.forEach((m) => {
        e === "bids" && (parseFloat(m[0]) > this.middle || parseFloat(m[0]) < r) || e === "asks" && (parseFloat(m[0]) < this.middle || parseFloat(m[0]) > d) || (Math.abs(c.p - m[0]) <= o / 2 && (n = parseFloat(m[1]), c.v = parseFloat(m[1])), c.t = n.toFixed(8));
      });
    }
    return i;
  }
  zoomLevel() {
    return 8;
  }
  dpr() {
    return 2;
  }
  /* x轴半轴长 */
  adjacent() {
    const e = (this.data.bids || []).length, s = (this.data.asks || []).length;
    return e < 1 || s < 1 ? 0 : this.sub(this.middle, this.minPrice());
  }
  getValueDecimal() {
    return parseInt(this.decimal.value);
  }
  getLocale() {
    return this.locale;
  }
  getLocaleMap() {
    return this.localeMap;
  }
  maxPrice() {
    return this.maxval;
  }
  minPrice() {
    return this.minval;
  }
  middlePrice() {
    return this.middlePriceVal;
  }
  maxVol() {
    const e = Math.round(this.ymaxval) / 10;
    return this.ymaxval + e;
  }
  getDataMaxVal(t) {
    const e = Math.round(t), i = e / 10;
    return e + i;
  }
  handleZoom() {
    const t = this.leftData, e = this.rightData, i = this.minPrice(), s = this.maxVol(), a = this.zoom;
    let o = 0;
    const n = a > 0 ? t.length + a : t.length - a * -1, r = this.zoomLevel() * 4;
    n <= 0 ? (this.zoom = 0, o = this.zoomLevel()) : n >= 200 ? (this.zoom = 0, o = 200) : n <= r ? o = r : o = n;
    const d = G([t[o], e[o]], "t")?.t || s, l = this.getDataMaxVal(d), c = a === 0 ? i : t[o]?.p || i, m = a === 0 ? s : l;
    this.zoomObj = { xPrice: c, ySum: m, dataIndex: o };
  }
  resetZoom() {
    this.zoom = -1, this.zoomObj = { xPrice: 0, ySum: 0, dataIndex: 200 };
  }
  fixedDecimal(t, e = 0) {
    if (!/e/.test(t) && t >= 1e3) return t;
    const i = new M(t), s = i.decimalPlaces();
    return e > 0 ? i.toFixed(e) : i.toFixed(s);
  }
  getPriceDecimal() {
    const e = K(this.middlePriceVal) ?? this.decimal.price;
    return parseInt(e);
  }
  toFixed(t, e) {
    if (isNaN(e) || t === 0)
      return 0;
    {
      let i = t + "";
      if (e || (e = 0), i.indexOf(".") === -1 && (i += "."), i += new Array(e + 1).join("0"), new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (e + 1) + "})?)\\d*$").test(i)) {
        let s = "0" + RegExp.$2;
        const a = RegExp.$1;
        let o = RegExp.$3.length, n = !0;
        if (o === e + 2) {
          if (o = s.match(/\d/g), parseInt(o[o.length - 1]) > 4)
            for (let r = o.length - 2; r >= 0 && (o[r] = parseInt(o[r]) + 1, o[r] === 10); r--)
              o[r] = 0, n = r !== 1;
          s = o.join("").replace(new RegExp("(\\d+)(\\d{" + e + "})\\d$"), "$1.$2");
        }
        return n && (s = s.substr(1)), (a + s).replace(/\.$/, "");
      }
    }
  }
  thousandBitSeparator(t) {
    if (t == null) return "";
    let e = t.toString();
    if (t >= 1e6) {
      const i = (t / 1e6).toString();
      return `${x(i)}M`;
    } else
      return e.includes(".") || (e += "."), e.replace(/(\d)(?=(\d{3})+\.)/g, function(i, s) {
        return s + ",";
      }).replace(/\.$/, "");
  }
  /* 刻度值显示规则处理 */
  getRenderTickLinesValue(t) {
    if (t == null || t === 0)
      return 0;
    if (t > 1e3 && t < 1e6) {
      const e = (t / 1e3).toString();
      return `${x(e)}K`;
    } else if (t >= 1e6) {
      const e = (t / 1e6).toString();
      return `${x(e)}M`;
    }
    return t.toString();
  }
  sub(...t) {
    return t = t.sort((i, s) => s - i), new M(t[0]).sub(new M(t[1])).toNumber();
  }
  add(...t) {
    return t.reduce((i, s) => new M(i).add(new M(s))).toNumber();
  }
}
function I(h) {
  h && h.stopPropagation ? h.stopPropagation() : window.event && (window.event.cancelBubble = !0), h && h.preventDefault ? h.preventDefault() : window.event && (window.event.returnValue = !1);
}
class Q {
  maskChart;
  dataProvider;
  viewPortHandler;
  waitingForMouseMoveAnimationFrame;
  constructor(t, e, i) {
    this.maskChart = t, this.dataProvider = e, this.viewPortHandler = i, this.waitingForMouseMoveAnimationFrame = !1;
  }
  mouseMove(t) {
    const { offsetX: e, offsetY: i } = t;
    I(t), this.waitingForMouseMoveAnimationFrame || (this.waitingForMouseMoveAnimationFrame = !0, this.maskChart.flushCanvas(e * this.dataProvider.dpr(), i * this.dataProvider.dpr()), this.waitingForMouseMoveAnimationFrame = !1);
  }
  mouseLeave(t) {
    I(t), this.maskChart.clearCanvas(), this.dataProvider.mouseIndex.offsetX = -1;
  }
  wheel(t) {
    const { deltaY: e } = t;
    I(t);
    const i = this.dataProvider.zoomLevel(), s = e > 0 ? 1 : -1, a = this.dataProvider.leftData.length;
    this.dataProvider.zoom = this.dataProvider.zoom === -1 ? 0 : this.dataProvider.zoom;
    const o = s === 1 ? this.dataProvider.zoom - i : this.dataProvider.zoom + i;
    o > -a && o < i && (this.dataProvider.zoom = o, this.dataProvider.handleZoom());
  }
}
const X = {
  background: "#0B1426",
  buyColor: "#41b37d",
  sellColor: "#d74e5a",
  maskColor: "rgba(0, 0, 0, 0.3)",
  lineColor: "#9497A9",
  globalAlpha: 0.3,
  lineWidth: 2,
  fontFamily: "Inter, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif"
}, J = {
  height: 30,
  line: {
    color: "#868993",
    size: 0.7
  },
  tickLine: {
    color: "#4A4858",
    size: 3,
    length: 8,
    space: 18
  },
  fontSize: 24,
  fontColor: "#868993"
}, Y = {
  width: 60,
  line: {
    color: "#868993",
    size: 1
  },
  tickLine: {
    color: "#4A4858",
    size: 3,
    length: 8,
    space: 5
  },
  position: "right",
  tickTextPosition: "outside",
  fontSize: 24,
  fontColor: "#868993"
}, tt = {
  height: 100,
  fontSize: 24,
  opacity: 0.9,
  radius: 8,
  color: "#FFF",
  backgroundColor: "#151D32",
  title: {
    fontSize: 24
  }
}, et = {
  depth: X,
  xAxis: J,
  yAxis: Y,
  tooltip: tt
};
class V {
  viewPortHandler;
  dataProvider;
  interval;
  styleConfig;
  constructor(t, e, i, s) {
    this.viewPortHandler = t, this.dataProvider = e, this.interval = i, this.styleConfig = s;
  }
}
let it = class extends V {
  localeMap;
  constructor(t, e, i, s) {
    super(t, e, i, s), this.interval = i, this.dataProvider = e, this.styleConfig = s, this.localeMap = this.dataProvider.getLocaleMap()[this.dataProvider.getLocale()];
  }
  point(t, e, i, s) {
    t.beginPath(), t.globalAlpha = 1, t.fillStyle = s, t.arc(e, i, 8, 0, 2 * Math.PI), t.fill(), t.closePath(), this.verticalLineDash(t, e, i, s), this.horizontalLineDash(t, e, i, s);
  }
  verticalLineDash(t, e, i, s) {
    const { buyColor: a, maskColor: o } = this.styleConfig.depth, n = this.viewPortHandler.contentRight(), r = this.viewPortHandler.contentBottom(), d = s === a, l = d ? 0 : e, c = 0, m = d ? e : n - e, g = r;
    t.setLineDash([5, 5]), t.lineWidth = 1.5, t.globalAlpha = 1, t.fillStyle = s, t.strokeStyle = s, t.beginPath(), t.moveTo(e, 0), t.lineTo(e, r), t.fillStyle = o, t.fillRect(l, c, m, g), t.stroke(), t.setLineDash([]);
  }
  horizontalLineDash(t, e, i, s) {
    const { buyColor: a } = this.styleConfig.depth, o = this.viewPortHandler.contentRight(), n = o / 2;
    t.setLineDash([5, 5]), t.lineWidth = 1.5, t.globalAlpha = 0.8, t.fillStyle = s, t.strokeStyle = s, t.beginPath(), s === a ? (t.moveTo(0, i), t.lineTo(n, i)) : (t.moveTo(o, i), t.lineTo(n, i)), t.stroke(), t.setLineDash([]);
  }
  drawAxisHighlightText(t, e, i, s, a, o) {
    const { thousandBitSeparator: n } = this.dataProvider, r = this.styleConfig.tooltip.fontSize, d = z(r), l = this.viewPortHandler.contentRight(), c = this.viewPortHandler.contentBottom(), m = this.dataProvider.getPriceDecimal(), g = this.dataProvider.getValueDecimal(), u = n(parseFloat(a.p).toFixed(m)), w = t.measureText(u).width, y = n(parseFloat(a.t).toFixed(g)), b = t.measureText(y).width + 1, k = 12, f = 14, P = 24, v = o ? l + k : 0;
    t.beginPath(), t.fillStyle = "black", t.fillRect(e - w / 2, c + f, w, P), t.globalAlpha = 1, t.fillStyle = s, t.fillRect(e, c, 1, 10), t.textAlign = "center", t.textBaseline = "top", t.font = d, t.fillText(u, e, c + f), t.closePath(), t.beginPath(), t.fillStyle = "black", t.fillRect(v, i - f, b, P), t.globalAlpha = 1, t.fillStyle = s, t.textAlign = "left", t.textBaseline = "middle", t.font = d, t.fillText(y, v, i), t.closePath();
  }
};
class st extends V {
  localeMap;
  constructor(t, e, i, s) {
    super(t, e, i, s), this.interval = i, this.dataProvider = e, this.styleConfig = s, this.localeMap = this.dataProvider.getLocaleMap()[this.dataProvider.getLocale()];
  }
  point(t, e, i, s) {
    t.beginPath(), t.globalAlpha = 1, t.fillStyle = s, t.arc(e, i, 8, 0, 2 * Math.PI), t.fill(), t.closePath(), this.verticalLineDash(t, e, i, s), this.horizontalLineDash(t, e, i, s);
  }
  verticalLineDash(t, e, i, s) {
    const { buyColor: a, maskColor: o } = this.styleConfig.depth, n = this.viewPortHandler.contentRight(), r = this.viewPortHandler.contentBottom(), d = s === a, l = 0, c = d ? i : 0, m = n, g = d ? r : i;
    t.setLineDash([5, 5]), t.lineWidth = 1.5, t.globalAlpha = 0.8, t.fillStyle = s, t.strokeStyle = s, t.beginPath(), t.moveTo(0, i), t.lineTo(n, i), t.fillStyle = o, t.fillRect(l, c, m, g), t.stroke(), t.setLineDash([]);
  }
  horizontalLineDash(t, e, i, s) {
    const { buyColor: a } = this.styleConfig.depth, o = this.viewPortHandler.contentBottom(), n = o / 2;
    t.setLineDash([5, 5]), t.lineWidth = 1.5, t.globalAlpha = 0.8, t.fillStyle = s, t.strokeStyle = s, t.beginPath(), s === a ? (t.moveTo(e, n), t.lineTo(e, o)) : (t.moveTo(e, 0), t.lineTo(e, n)), t.stroke(), t.setLineDash([]);
  }
  drawAxisHighlightText(t, e, i, s, a, o, n) {
    const { thousandBitSeparator: r } = this.dataProvider, { tooltip: d } = this.styleConfig, l = d.fontSize, c = z(l), m = this.viewPortHandler.contentRight(), g = this.viewPortHandler.contentBottom(), u = this.dataProvider.getPriceDecimal(), w = this.dataProvider.getValueDecimal(), y = r(parseFloat(a.p).toFixed(u)), b = t.measureText(y).width + 4, k = r(parseFloat(a.t).toFixed(w)), f = t.measureText(k).width + 1, P = 14, v = 26, C = 39, D = 40, p = !o && i > g - D ? g - C : o && i < D ? C : i, S = b + P, H = m - P;
    t.beginPath(), t.fillStyle = "#0B1426", t.textAlign = "right", t.textBaseline = "middle", t.fillRect(m - S, p - P, b, v), t.globalAlpha = 1, t.fillStyle = s, t.font = c, t.fillText(y, H, p), t.closePath();
    const R = o ? 0 : g - v, A = f / 2, T = n <= 10 ? e + A - 2 : e;
    t.beginPath(), t.fillStyle = "#0B1426", t.textAlign = "center", t.textBaseline = "top", t.fillRect(T - A, R, f, v), t.globalAlpha = 1, t.fillStyle = s, t.font = c, t.fillText(k, T, R), t.closePath();
  }
}
class ot {
  width;
  height;
  contentRect;
  isVertical;
  constructor() {
    this.contentRect = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.height = 0, this.width = 0, this.isVertical = !1;
  }
  getVertical() {
    return this.isVertical;
  }
  /**
   * 设置尺寸
   * @param width
   * @param height
   * @param offsetLeft
   * @param offsetRight
   * @param offsetTop
   * @param offsetBottom
   */
  setDimensions(t, e, i, s, a, o) {
    this.width = t, this.height = e, this.contentRect.left = i, this.contentRect.right = s, this.contentRect.top = a, this.contentRect.bottom = o, this.isVertical = t / 2 < 600;
  }
  contentTop() {
    return this.isVertical ? this.contentRect.left : this.contentRect.top;
  }
  contentLeft() {
    return this.isVertical ? this.contentRect.top : this.contentRect.left;
  }
  contentRight() {
    return this.isVertical ? this.width : this.width - this.contentRect.right - 10;
  }
  contentBottom() {
    return this.isVertical ? this.height : this.height - this.contentRect.bottom;
  }
  getContentCenter() {
    const t = { x: 0, y: 0 };
    return this.isVertical ? (t.x = (this.contentLeft() + this.contentBottom()) / 2, t.y = (this.contentTop() + this.contentRight()) / 2) : (t.x = (this.contentLeft() + this.contentRight()) / 2, t.y = (this.contentTop() + this.contentBottom()) / 2), t;
  }
}
class W {
  viewPortHandler;
  canvasDom;
  ctx;
  dpr;
  constructor() {
    this.viewPortHandler = new ot();
  }
  init(t) {
    if (t) {
      const e = document.createElement("canvas");
      e.style.position = "absolute", e.style.right = "0", e.style.left = "0", this.canvasDom = e, this.ctx = this.canvasDom.getContext("2d"), this.dpr = 2, t.appendChild(this.canvasDom);
    }
  }
  /**
    * 设置图尺寸
    * @param chartTop
    * @param width
    * @param height
    * @param offsetLeft
    * @param offsetRight
    * @param offsetTop
    * @param offsetBottom
  */
  setChartDimensions(t, e, i, s, a, o = 0, n = 25) {
    this.clearCanvas();
    const r = e, d = i, l = e * this.dpr, c = i * this.dpr;
    this.canvasDom.width = l, this.canvasDom.height = c, this.canvasDom.style.top = `${t}px`, this.canvasDom.style.width = `${r}px`, this.canvasDom.style.height = `${d}px`, this.canvasDom.style.overflow = "hidden", this.viewPortHandler.setDimensions(l, c, s, a, o, n), this.draw();
  }
  flush() {
    this.clearCanvas(), this.draw();
  }
  clearCanvas() {
    this.ctx.clearRect(0, 0, this.viewPortHandler.width, this.viewPortHandler.height);
  }
  draw() {
  }
}
class nt extends W {
  interval;
  dataProvider;
  maskRender;
  verticalMaskRender;
  maxVol;
  style;
  constructor(t, e, i, s) {
    super(), this.interval = i, this.maxVol = 0, this.style = s, this.dataProvider = e, this.maskRender = new it(this.viewPortHandler, e, i, s), this.verticalMaskRender = new st(this.viewPortHandler, e, i, s);
  }
  renderDraw(t, e) {
    if (!t) return !1;
    const { depth: i } = this.style, { zoomObj: s, leftData: a, rightData: o } = this.dataProvider;
    let n = 0;
    const r = s?.ySum || this.dataProvider.maxVol(), d = this.viewPortHandler.contentRight(), l = this.viewPortHandler.contentBottom(), c = d / 2, m = c - this.interval / 2, g = c + this.interval / 2, u = s.dataIndex - 1, w = s.dataIndex;
    if (m < t && t < g || t > d || t < 0) return !1;
    const y = t > c, b = i.buyColor, k = i.sellColor, f = m / w, P = Math.floor(t / f) || 0, v = u - (P - w);
    t > 0 && (this.dataProvider.mouseIndex = { offsetX: t }), n = v * f;
    const C = Math.floor(this.interval / f) || 0;
    let D = P > u ? P - C : P, p = v > u ? v - C : v, S = [], H = [];
    y ? (S = o, D = D - w, H = a, p = u - p) : (S = a, D = u - D, H = o, p = p - w);
    const R = S[D], A = H[p];
    if (R && A) {
      const L = l - R.t / r * l, T = y ? k : b;
      this.maskRender.point(this.ctx, t, L, T), this.maskRender.drawAxisHighlightText(this.ctx, t, L, T, R, y);
      const F = l - A.t / r * l, j = y ? b : k;
      this.maskRender.point(this.ctx, n, F, j), this.maskRender.drawAxisHighlightText(this.ctx, n, F, j, A, !y);
    }
  }
  renderVerticalDraw(t, e) {
    if (!e) return !1;
    const i = this.viewPortHandler.contentRight(), s = this.viewPortHandler.contentBottom(), { depth: a } = this.style, o = a.buyColor, n = a.sellColor, r = s / 2, d = r - this.interval / 2, l = r + this.interval / 2, c = this.dataProvider.zoomObj.dataIndex - 1, m = this.dataProvider.zoomObj.dataIndex, g = this.dataProvider.zoomObj?.ySum || this.dataProvider.maxVol();
    if (d < e && e < l || e > s || e < 0) return !1;
    const u = d / m, w = e < r, y = Math.floor((s - e) / u) || 0, b = m - (y - c);
    e > 0 && (this.dataProvider.mouseIndex = { offsetY: e });
    const k = Math.floor(this.interval / u) || 0;
    let f = y > c ? y - k : y, P = b > c ? b - k : b, v = [], C = [];
    w ? (v = this.dataProvider.rightData, f = f - m, C = this.dataProvider.leftData, P = c - P) : (v = this.dataProvider.leftData, f = c - f, C = this.dataProvider.rightData, P = P - m);
    const D = v[f], p = C[P];
    if (D && p) {
      const S = D.t / g * i, H = w ? n : o;
      this.verticalMaskRender.point(this.ctx, S, e, H), this.verticalMaskRender.drawAxisHighlightText(this.ctx, S, e, H, D, w, f);
      const R = p.t / g * i, A = s - e - p.t / g, L = w ? o : n;
      this.verticalMaskRender.point(this.ctx, R, A, L), this.verticalMaskRender.drawAxisHighlightText(this.ctx, R, A, L, p, !w, P);
    }
  }
  flushCanvas(t, e) {
    this.clearCanvas(), this.viewPortHandler.getVertical() ? this.renderVerticalDraw(t, e) : this.renderDraw(t, e);
  }
}
class N extends V {
  constructor(t, e, i, s) {
    super(t, e, i, s), this.interval = i, this.dataProvider = e, this.styleConfig = s;
  }
}
function at(h) {
  const t = h?.offsetWidth || 0;
  return t > 0 && t < 720 ? 3 : t > 0 && t < 800 ? 5 : t < 1400 ? 7 : 9;
}
let rt = class extends N {
  /**
   * 绘制轴线
   * @param ctx
   * @param xAxis
   */
  renderAxisLine(t, e) {
    t.strokeStyle = e.line.color, t.lineWidth = e.line.size, t.globalAlpha = 0.4, t.beginPath(), t.moveTo(this.viewPortHandler.contentLeft(), this.viewPortHandler.contentBottom()), t.lineTo(this.viewPortHandler.contentRight(), this.viewPortHandler.contentBottom()), t.stroke(), t.closePath();
  }
  /**
   * 绘制刻度
   * @param ctx
   * @param xAxis
   */
  renderTickLines(t, e, i) {
    const { tickLine: s, fontSize: a, fontColor: o } = i, n = at(t), r = s.length, d = s.space, l = this.dataProvider, c = this.viewPortHandler;
    e.textAlign = "center", e.globalAlpha = 0.9, e.strokeStyle = s.color, e.fillStyle = o, e.lineWidth = s.size, e.font = z(a);
    const m = c.contentBottom(), g = m + r, u = c.contentRight() / (n * 2), w = 0, y = u * 2, b = l.getPriceDecimal(), k = l.fixedDecimal(l.adjacent() * 2, b), f = l.fixedDecimal(k / (n * 2), b), P = l.fixedDecimal(f * 2, b), v = l?.zoomObj?.xPrice || l.minPrice(), C = l.fixedDecimal(l.add(v, f));
    for (let D = 0; D < n; D++) {
      const p = l.add(l.add(w, u), D * y), S = l.toFixed(l.fixedDecimal(l.add(C, D * P)), b), H = l.thousandBitSeparator(S);
      e.beginPath(), e.moveTo(p, m), e.lineTo(p, g), e.fillText(H ?? 0, p, g + d), e.stroke(), e.closePath();
    }
  }
};
function lt(h) {
  const t = h?.offsetHeight || 0;
  return t > 0 && t < 50 ? { tickCount: 1, tickHeight: 3 } : t > 0 && t < 100 ? { tickCount: 3, tickHeight: 5 } : t > 0 && t < 200 ? { tickCount: 4, tickHeight: 10 } : t > 0 && t < 400 ? { tickCount: 6, tickHeight: 16 } : t > 0 && t < 500 ? { tickCount: 7, tickHeight: 19 } : t < 900 ? { tickCount: 9, tickHeight: 26 } : { tickCount: 9, tickHeight: 26 };
}
function O(h, t) {
  let e = h || "0";
  return isNaN(h) ? e = "0" : h > 0 && h < 1e3 && !U(h) ? e = String(t.toFixed(h, t.getValueDecimal())) : h > 0 && h > 1e3 && (e = t.getRenderTickLinesValue(h)), e.toString();
}
class ht extends N {
  /**
   * 绘制轴线
   * @param ctx: any
   * @param yAxis: any
   */
  renderAxisLine(t, e) {
    t.strokeStyle = e.line.color, t.lineWidth = e.line.size, t.globalAlpha = 0.4, t.beginPath(), e.position === "left" ? (t.moveTo(
      this.viewPortHandler.contentLeft(),
      this.viewPortHandler.contentTop()
    ), t.lineTo(
      this.viewPortHandler.contentLeft(),
      this.viewPortHandler.contentBottom()
    )) : (t.moveTo(
      this.viewPortHandler.contentRight(),
      this.viewPortHandler.contentTop()
    ), t.lineTo(
      this.viewPortHandler.contentRight(),
      this.viewPortHandler.contentBottom()
    )), t.stroke(), t.closePath();
  }
  /**
   * 绘制刻度
   * @param ctx
   * @param yAxis
   */
  renderTickLines(t, e, i) {
    const { tickLine: s, fontSize: a, fontColor: o } = i, { tickCount: n, tickHeight: r } = lt(t), d = s.space, l = s.length, c = this.viewPortHandler, m = this.dataProvider;
    e.textBaseline = "middle", e.textAlign = "left", e.globalAlpha = 0.9, e.fillStyle = o, e.strokeStyle = s.color, e.lineWidth = s.size, e.font = z(a);
    let g, u;
    i.position === "left" ? (g = c.contentLeft(), i.tickTextPosition === "outside" ? u = g - l : u = g + l) : (g = c.contentRight(), i.tickTextPosition === "outside" ? u = g + l : u = g - l);
    const w = c.contentBottom(), y = m.zoomObj?.ySum || m.maxVol(), b = w / r * 3, k = y / r * 3;
    let f = 0;
    const P = [];
    for (let v = 1; v < n; v++) {
      const C = O(k * v, m);
      P.push(C.length);
    }
    f = Z(P);
    for (let v = 1; v < n; v++) {
      const C = w - b * v, D = k * v;
      let p = i.fontSize, S = "0";
      S = O(D, m), f > 7 && p !== 12 && (p = i.fontSize - f / 3 || 24, e.font = z(p)), e.beginPath(), e.moveTo(g, C), e.lineTo(u, C), e.fillText(S, u + d, C), e.stroke(), e.closePath();
    }
  }
}
function $(h, t, e) {
  const i = h.createLinearGradient(0, 0, 0, e);
  return i.addColorStop(0, t.buyColor), i.addColorStop(0.2, "#25b271e0"), i.addColorStop(0.4, "#25b271c7"), i.addColorStop(0.6, "#25b271a1"), i.addColorStop(0.8, "#25b2717d"), i.addColorStop(1, "#25b27136"), i;
}
function E(h, t, e) {
  const i = h.createLinearGradient(0, 0, 0, e);
  return i.addColorStop(0, t.sellColor), i.addColorStop(0.2, "#f5395ee0"), i.addColorStop(0.4, "#f5395ec4"), i.addColorStop(0.6, "#f5395ea6"), i.addColorStop(0.8, "#f5395e78"), i.addColorStop(1, "#f5395e4d"), i;
}
class dt extends V {
  renderDraw(t, e) {
    const i = this.dataProvider.zoomObj?.ySum || this.dataProvider.maxVol(), s = this.dataProvider.middlePrice(), a = (this.viewPortHandler.contentRight() - this.interval) / 2, o = this.viewPortHandler.contentBottom(), n = this.dataProvider.zoom === -1 ? this.dataProvider.leftData.length : this.dataProvider.zoomObj.dataIndex, r = this.dataProvider.leftData.slice(0, n + 1), d = this.dataProvider.rightData.slice(0, n + 1), l = a / n, c = a / n, { background: m } = e;
    this.drawBg(t, this.viewPortHandler.width, this.viewPortHandler.height, m), this.drawLeft(t, a, o, i, r, l, e), this.drawRight(t, a, o, i, d, c, e), this.drawCenterLine(t, o, s, m);
  }
  renderVerticalDraw(t, e) {
    const i = this.dataProvider.zoomObj?.ySum || this.dataProvider.maxVol(), s = this.dataProvider.middlePrice(), a = this.viewPortHandler.contentBottom() / 2, o = this.viewPortHandler.contentRight(), n = this.dataProvider.zoom === 0 ? this.dataProvider.leftData.length : this.dataProvider.zoomObj.dataIndex, r = this.dataProvider.rightData.slice(0, n), d = this.dataProvider.leftData.slice(0, n), l = a / n, c = a / n, { background: m } = e;
    this.drawBg(t, this.viewPortHandler.height, this.viewPortHandler.width, m), this.drawLeft(t, a, o, i, r, l, e), this.drawRight(t, a, o, i, d, c, e), this.drawCenterLine(t, o, s, m);
  }
  drawLeft(t, e, i, s, a, o, n) {
    let r = 0, d = 0;
    const l = this.viewPortHandler.getVertical();
    t.beginPath(), t.lineWidth = n.lineWidth, t.moveTo(e, i), a.forEach((c, m) => {
      r = e - m * o, d = i - c.t / s * i, t.lineTo(r, d);
    }), t.fillStyle = l ? E(t, n, i) : $(t, n, i), t.strokeStyle = l ? n.sellColor : n.buyColor, t.stroke(), t.globalAlpha = n.globalAlpha, t.lineTo(0, d), t.lineTo(0, i), t.fill(), t.closePath();
  }
  drawRight(t, e, i, s, a, o, n) {
    let r = 0, d = 0;
    const l = this.viewPortHandler.getVertical();
    t.beginPath(), t.globalAlpha = 1, t.lineWidth = n.lineWidth, t.moveTo(e + this.interval, i), a.forEach((c, m) => {
      r = e + parseInt(m) * o + 1, d = i - c.t / s * i, t.lineTo(r, d);
    }), t.fillStyle = l ? $(t, n, i) : E(t, n, i), t.strokeStyle = l ? n.buyColor : n.sellColor, t.shadowColor = "none", t.stroke(), t.globalAlpha = n.globalAlpha, t.lineTo(e * 2 + this.interval, d), t.lineTo(e * 2 + this.interval, i), t.fill(), t.closePath();
  }
  drawBg(t, e, i, s) {
    t.beginPath(), t.globalAlpha = 1, t.fillStyle = s, t.fillRect(0, 0, e, i), t.closePath();
  }
  drawCenterLine(t, e, i, s) {
    const { x: a } = this.viewPortHandler.getContentCenter(), { thousandBitSeparator: o } = this.dataProvider, n = this.viewPortHandler.getVertical(), { tooltip: r, depth: d } = this.styleConfig, l = z(r.fontSize), c = 13;
    t.globalAlpha = 1, t.strokeStyle = d.lineColor, t.lineWidth = 1, t.beginPath(), t.moveTo(a, 0), t.lineTo(a, e), t.stroke(), t.save();
    const g = t.measureText(i).width * 3;
    n && (t.fillStyle = s, t.fillRect(a - c, 10, 24, g), t.fillStyle = d.lineColor, t.textAlign = "left", t.textBaseline = "middle", t.font = l, t.translate(a, g), t.rotate(-Math.PI / 2), t.fillText(o(i), 0, 0), t.restore()), t.closePath();
  }
  drawHorizontalChart(t) {
    if (this.dataProvider.zoom !== -1)
      return !1;
    t.translate(t.canvas.width, 0), t.rotate(Math.PI / 2);
  }
}
class ct extends W {
  interval;
  dataProvider;
  style;
  mainRender;
  xAxisRender;
  yAxisRender;
  dom;
  constructor(t, e, i, s) {
    super(), this.style = s, this.interval = 0, this.dom = t, this.xAxisRender = new rt(this.viewPortHandler, e, i, s), this.yAxisRender = new ht(this.viewPortHandler, e, i, s), this.mainRender = new dt(this.viewPortHandler, e, i, s), this.dataProvider = e;
  }
  refresh() {
    const { xAxis: t, yAxis: e, depth: i } = this.style;
    this.viewPortHandler.getVertical() ? this.mainRender.renderVerticalDraw(this.ctx, i) : (this.mainRender.renderDraw(this.ctx, i), this.xAxisRender.renderAxisLine(this.ctx, t), this.xAxisRender.renderTickLines(this.dom, this.ctx, t, e), this.yAxisRender.renderAxisLine(this.ctx, e), this.yAxisRender.renderTickLines(this.dom, this.ctx, e));
  }
  draw() {
    const { xAxis: t, yAxis: e, depth: i } = this.style;
    this.viewPortHandler.getVertical() ? (this.mainRender.drawHorizontalChart(this.ctx), this.mainRender.renderVerticalDraw(this.ctx, i)) : (this.mainRender.renderDraw(this.ctx, i), this.xAxisRender.renderAxisLine(this.ctx, t), this.xAxisRender.renderTickLines(this.dom, this.ctx, t, e), this.yAxisRender.renderAxisLine(this.ctx, e), this.yAxisRender.renderTickLines(this.dom, this.ctx, e));
  }
}
class ut extends W {
  dom;
  width;
  height;
  theme;
  data;
  storageDepthObj;
  instrumentName;
  decimal;
  interval;
  styleConfig;
  locale;
  localeMap;
  selectLocale;
  throttle;
  dataProvider;
  mainChart;
  maskChart;
  constructor(t) {
    super();
    const { dom: e, chartsData: i, theme: s, instrumentName: a, options: o } = t, { decimal: n, interval: r, style: d, locale: l, localeMap: c, selectLocale: m } = o;
    this.dpr = 2, this.dom = e, e.style.position = "relative", this.width = this.dom.offsetWidth, this.height = this.dom.offsetHeight, this.theme = s || "", this.data = this.filterChartsData(i), this.decimal = {
      price: n && n.price || 3,
      value: n && n.value || 4
    }, this.interval = r || 2, this.styleConfig = this.deepObjectMerge(et, d), this.locale = l || "en", this.localeMap = c || { en: { price: "Price", sum: "Sum" } }, this.selectLocale = m, this.throttle = null, this.storageDepthObj = {}, this.instrumentName = a, this.dataProvider = new _(), this.dataProvider.init(this.data, this.decimal), this.mainChart = new ct(this.dom, this.dataProvider, this.interval, this.styleConfig), this.mainChart.init(this.dom), this.maskChart = new nt(this.dom, this.dataProvider, this.interval, this.styleConfig), this.maskChart.init(this.dom), this.calcChartDimensions(), this.initEvent();
  }
  resizeChartEvent(t, e) {
    e || (e = t.parentElement?.className || "e-depth-chart");
    const i = document.querySelector(`.${e}`);
    new ResizeObserver(() => {
      if (t) {
        const { clientHeight: a, clientWidth: o } = i;
        t.style.width = `${o}px`, t.style.height = `${a}px`, this.updateSize(o, a);
      }
    }).observe(i);
  }
  // 初始化事件
  initEvent() {
    const t = new Q(
      this.maskChart,
      this.dataProvider,
      this.viewPortHandler
    ), e = this.dom;
    e.addEventListener("mousemove", (i) => {
      t.mouseMove(i);
    }), e.addEventListener("mouseleave", (i) => {
      t.mouseLeave(i);
    }), e.addEventListener("wheel", (i) => {
      t.wheel(i), this.mainChart.flush(), this.maskChart.flushCanvas(this.dataProvider.mouseIndex.offsetX, this.dataProvider.mouseIndex.offsetY);
    });
  }
  // 修改数据源
  update(t, e) {
    try {
      this.data = t, e && e !== this.instrumentName && (this.dataProvider.resetZoom(), this.instrumentName = e);
      const i = JSON.stringify(this.storageDepthObj);
      i === "{}" || i !== "{}" && this.storageDepthObj.middlePrice !== this.data.middlePrice ? (this.storageDepthObj = this.loadStorageDepthData(t), this.dataProvider.init(this.storageDepthObj, this.decimal)) : (this.storageDepthObj.bids = t.bids, this.storageDepthObj.asks = t.asks, this.storageDepthObj.yminval = t.yminval, this.storageDepthObj.ymaxval = t.ymaxval, this.dataProvider.init(this.storageDepthObj, this.decimal)), this.mainChart.refresh(), this.dataProvider?.mouseIndex.offsetX > 0 && this.maskChart.flushCanvas(this.dataProvider.mouseIndex.offsetX);
    } catch (i) {
      console.warn("depth chart update error", i);
    }
  }
  // 修改图表尺寸
  updateSize(t, e) {
    const i = this.calcXAxisHeight(), s = this.calcYAxisWidth(), a = this.width = t, o = this.height = e;
    let n = 0, r = 0;
    const d = 0, l = i;
    this.styleConfig.yAxis.position === "left" ? n = s : r = s, this.dataProvider.resetZoom(), this.mainChart.setChartDimensions(0, a, o, n, r, d, l), this.maskChart.setChartDimensions(0, a, o, n, r, d, l);
  }
  // 切换本地化语言
  updateLocale({ locale: t, localeMap: e }) {
    t && (this.locale = t), this.dataProvider.init(this.data, this.decimal, t, e), this.maskChart.flushCanvas();
  }
  // 计算图的尺寸
  calcChartDimensions() {
    const t = this.calcXAxisHeight(), e = this.calcYAxisWidth(), i = this.width, s = this.height;
    let a = 0, o = 0;
    const n = 0, r = t;
    this.styleConfig.yAxis.position === "left" ? a = e : o = e, this.mainChart.setChartDimensions(0, i, s, a, o, n, r), this.maskChart.setChartDimensions(0, i, s, a, o, n, r);
  }
  /**
   * 计算x轴高度
   */
  calcXAxisHeight() {
    return this.styleConfig.xAxis.height * this.dpr;
  }
  /**
   * 计算y轴宽度
   */
  calcYAxisWidth() {
    return this.styleConfig.yAxis.width * this.dpr;
  }
  deepObjectMerge(t, e) {
    for (const i in e)
      t[i] = t[i] && t[i].toString() === "[object Object]" ? this.deepObjectMerge(t[i], e[i]) : t[i] = e[i];
    return t;
  }
  // 处理每次更新的数据，x轴 * 5倍，x轴数据固定，切换币种会更新数据
  loadStorageDepthData(t) {
    const e = t;
    return e && e.length > 0 && (e.minval = t.minval, e.maxval = t.maxval * 5, e.middlePrice = t.middlePrice * 5), e;
  }
  /**
   * @param data
   * bids: [[0, 0]]
   * asks: [[0, 0]]
   * minval: 0
   * maxval: 0
   * yminval: 0
   * ymaxval: 0
   * middlePrice: 0
  */
  filterChartsData(t) {
    return t.bids = B(t.bids) ? [[0, 0]] : t.bids, t.asks = B(t.asks) ? [[0, 0]] : t.asks, t;
  }
}
export {
  ut as D,
  z as g
};
//# sourceMappingURL=plugin.js-DH6AlshY.js.map
